import { useEffect, useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { userService } from "../../../services/CommonServices";
import GlobalContext from "../../../context/GlobalContext";
import { CSVLink, CSVDownload } from "react-csv";
import { downloadExcel } from "react-export-table-to-excel";
import ReactPaginate from 'react-paginate';
import * as XLSX from "xlsx";
import Loader from '../../Loader/Loader';

const EmployeesList=(props)=>{
    
    let navigate = useNavigate();
    var globalData=useContext(GlobalContext)
    const[res,setRes]=useState([])
    const[resAll,setResAll]=useState([])
    const[page,setPage]=useState(0)

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [isLoading, setIsLoading] = useState(true);

    const handleStartDateChange = (event) => {
      // Update the state with the new input value
      setStartDate(event.target.value);
    };
    
    const handleEndDateChange = (event) => {
      // Update the state with the new input value
      setEndDate(event.target.value);
    };

    const clearSearchedFeilds = (event) => {
      setStartDate('');
      setEndDate('');
      setRes(resAll);
    };

    function performSearch(event) {
      event.preventDefault();
      if(startDate == '' || startDate == undefined || startDate == null) {
        alert("Kindly select start date.");
        return;
      }
      if(endDate == '' || endDate == undefined || endDate == null) {
        alert("Kindly select end date.");
        return;
      }
      var temp = [];
      for(var i = 0; i < resAll.length; i++) {
        var age = new Date(resAll[i].dateCreated);
        var startDate2 = new Date(startDate);
        var endDate2 = new Date(endDate);
        startDate2.setHours(0);
        startDate2.setMinutes(0);
        startDate2.setSeconds(0);
        endDate2.setHours(23);
        endDate2.setMinutes(59);
        endDate2.setSeconds(59);
        if(age.getTime() >= startDate2.getTime() && age.getTime() <= endDate2.getTime()) {
          temp.push(resAll[i]);
        }
      }
      setRes(temp);
    }

    useEffect(()=>{
        get_employees_list(page);
    },[])

    function get_employees_list(page_temp) {
        const payload = {
            "organizationId" : globalData.org_id,
            "numberOfRows" : 50,
            "offset" : (page_temp * 50)
        }
        const headers = {
            "Authorization" : globalData.token
        }
        userService.employees_list_api(payload, headers).then(response=>{
            if(response.status==200){
                for(var i = 0; i < response.data.employees.length; i++) {
                  var date = new Date(response.data.employees[i].dateCreated);
                  var year = date.getFullYear();
                  var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so we add 1
                  var day = date.getDate().toString().padStart(2, '0');
                  var hours = date.getHours().toString().padStart(2, '0');
                  var minutes = date.getMinutes().toString().padStart(2, '0');
                  var seconds = date.getSeconds().toString().padStart(2, '0');
                  response.data.employees[i].dateCreated = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }
                setRes(res => [...res, ...response.data.employees]);
                setResAll(resAll => [...resAll, ...response.data.employees]);
                if(response.data.employees.length == 50) {
                  setPage(page_temp + 1);
                  get_employees_list(page_temp + 1);
                } else {
                  setIsLoading(false);
                }
            }
        }).catch(error => {
          setIsLoading(false);
            if(error.response.status == 401) {
              globalData.set_token("")
              globalData.set_org_id("")
              sessionStorage.removeItem('token')
              sessionStorage.removeItem('org_id')
              //location.reload(true);
              navigate('/login')
            }
        });
    }

    function Items({ currentItems }) {
        return (
          <>
            {currentItems &&
              currentItems.map((item) => (
                <tr>
                    <td>{item.id}</td>
                    <td>{item.uuid}</td>
                    <td>{item.dateCreated}</td>
                    <td>{item.lastUpdated}</td>
                    <td>{item.status}</td>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.honorific}</td>
                    <td>{item.designation}</td>
                    <td>{item.profilePageUrl}</td>
                    <td>{item.profileId}</td>
                    <td>{item.profileIcon}</td>
                    <td>{item.gender}</td>
                    <td>{item.employeeOfferings}</td>
                    <td>{item.sortOrder}</td>
                    <td>{item.displayProfile}</td>
                    <td>{item.rating}</td>
                    <td>{item.ratingCount}</td>
                    <td>{item.adminApproved}</td>
                    <td>{item.googleCalendarEnabled}</td>
                    <td>{item.joiningDate}</td>
                    <td>{item.billConsultation}</td>
                    <td>{item.accessToPatientBriefing}</td>
                    <td>{item.videoSlotCount}</td>
                    <td>{item.inPatientSlotCount}</td>
                    <td>{item.questionSlotCount}</td>
                </tr>
              ))}
          </>
        );
    }


    function PaginatedItems({ itemsPerPage }) {
        const [itemOffset, setItemOffset] = useState(0);
    
        const endOffset = itemOffset + itemsPerPage;
        console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        const currentItems = res.slice(itemOffset, endOffset);
        const pageCount = Math.ceil(res.length / itemsPerPage);
    
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % res.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
        };
    
        return (
        <>
            <Items currentItems={currentItems} />
            <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            />
        </>
        );
    }
    
      const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(res);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
        XLSX.writeFile(wb, "exported_data.xlsx");
      };



  
return(

            <div class="content_area">
                        <div>
                          {isLoading && (
                            <Loader /> // Render the loader component while loading
                          )}
                        </div>
                        <div class="tables_area">
                        <div class="title-box">

                        <h2 class="pull-left">Employees List</h2>
                        <CSVLink data={res} className="blue_btn yellow_btn pull-right text-uppercase">Download CSV</CSVLink>
                        <a onClick={exportToExcel} class="blue_btn yellow_btn pull-right text-uppercase">Download excel</a>&nbsp;
                        <div class="clear"></div>
                        </div>
                        <div class="filter-box">
                        Date Created : 
                        <input type="date" value={startDate} onChange={handleStartDateChange} />
                        <input type="date" value={endDate} onChange={handleEndDateChange} />
                        <a onClick={performSearch} class="blue_btn yellow_btn text-uppercase">Search</a>
                        <a onClick={clearSearchedFeilds} class="blue_btn yellow_btn text-uppercase">Clear</a>
                        </div>
                            <div class="white_box">
                                <div class="table-responsive">
                                    <table width="100%" cellspacing="0" cellpadding="0">
                                        <thead>
                                            <tr>
                                                <th>id</th>
                                                <th>uuid</th>
                                                <th>dateCreated</th>
                                                <th>lastUpdated</th>
                                                <th>status</th>
                                                <th>firstName</th>
                                                <th>lastName</th>
                                                <th>honorific</th>
                                                <th>designation</th>
                                                <th>profilePageUrl</th>
                                                <th>profileId</th>
                                                <th>profileIcon</th>
                                                <th>gender</th>
                                                <th>employeeOfferings</th>
                                                <th>sortOrder</th>
                                                <th>displayProfile</th>
                                                <th>rating</th>
                                                <th>ratingCount</th>
                                                <th>adminApproved</th>
                                                <th>googleCalendarEnabled</th>
                                                <th>joiningDate</th>
                                                <th>billConsultation</th>
                                                <th>accessToPatientBriefing</th>
                                                <th>videoSlotCount</th>
                                                <th>inPatientSlotCount</th>
                                                <th>questionSlotCount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <PaginatedItems itemsPerPage={50} />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    

                    </div>
);
};
export default EmployeesList;